"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureHookManager = void 0;
const feature_1 = require("../log/feature");
const isPromise = (item) => !!item.then;
/**
 * {@inheritDoc IFeatureHookManager}
 */
class FeatureHookManager {
    constructor() {
        this.hookPayloads = [];
        this.registeredCallbacks = [];
        this.registeredMutateHooks = [];
    }
    /** {@inheritDoc IFeatureHookManager.registerHook} */
    registerHook(name, invokeCallback) {
        (0, feature_1.debug)('register hook %s', name);
        this.registeredCallbacks.push({ name, callback: invokeCallback });
        const payloads = this.hookPayloads.filter(payload => {
            return payload.name === name;
        });
        for (const payload of payloads) {
            invokeCallback(payload.callingFeature, payload.payload);
        }
    }
    /** {@inheritDoc IFeatureHookManager.hook} */
    hook(feature, name, payload) {
        (0, feature_1.debug)('hook %s, from %s', name, feature.constructor.name);
        this.hookPayloads.push({
            name,
            payload,
            callingFeature: feature,
        });
        const callbacks = this.registeredCallbacks.filter(c => c.name === name);
        for (const callback of callbacks) {
            if (callback.callback) {
                callback.callback(feature, payload);
            }
        }
    }
    /** {@inheritDoc IFeatureHookManager.registerMutateHook} */
    registerMutateHook(name, mutateCallback) {
        (0, feature_1.debug)('register mutate hook %s', name);
        this.registeredMutateHooks.push({
            name,
            callback: mutateCallback,
        });
    }
    /** {@inheritDoc IFeatureHookManager.mutateHook} */
    mutateHook(name, payload, context, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, feature_1.debug)('calling mutate hook %s', name);
            const { reverse = false } = opts || {};
            let result = payload;
            let hooks = this.registeredMutateHooks.filter(hook => {
                return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
            });
            if (reverse) {
                (0, feature_1.debug)('reversing hook order...');
                hooks = [...hooks].reverse();
            }
            for (const registeredHook of hooks) {
                result = yield registeredHook.callback(result, context);
            }
            return result;
        });
    }
    /** {@inheritDoc IFeatureHookManager.mutateHookSync} */
    mutateHookSync(name, payload, context, opts) {
        const { reverse = false } = opts || {};
        let result = payload;
        let hooks = this.registeredMutateHooks.filter(hook => {
            return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
        });
        if (reverse) {
            (0, feature_1.debug)('mutate hook (sync): reversing hook order...');
            hooks = [...hooks].reverse();
        }
        for (const registeredHook of hooks) {
            const hookResult = registeredHook.callback(result, context);
            if (isPromise(hookResult)) {
                throw new Error('A promise was returned when mutateHookSync() was called');
            }
            result = hookResult;
        }
        return result;
    }
}
exports.FeatureHookManager = FeatureHookManager;
//# sourceMappingURL=FeatureHookManager.js.map